document.addEventListener('DOMContentLoaded',()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isMobile = window.innerWidth <= 768;
    const AUTOPLAY_DELAY = 3000; 

    const currentPage = sessionStorage.getItem('currentPage');
    const lastPage = sessionStorage.getItem('previousPage');
    const UtmPage = sessionStorage.getItem('utmProductPage');
    if (lastPage && lastPage.includes('/products/')) {
        const afterProducts = lastPage.split('/products/')[1];
        const withoutQuery = afterProducts.split('?')[0];
        const withoutHash = withoutQuery.split('#')[0];
        const handle = withoutHash.split('/')[0]; 

        if (sessionStorage.getItem('not_interested') === 'true') {
            console.warn("Fetch skipped: User is not interested (Session Storage flag found).");
        }else{
            fetch(`/pages/page-collection-byob-2-0-ci-lead-products`)
            .then(response => response.text())
            .then(htmlString => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');
                const sectionEl = doc.querySelector('[data-section-type="collection-byob-2-0-lead"]');
                if (!sectionEl || !sectionEl.dataset.sectionId) return;
                const sectionId = sectionEl.dataset.sectionId;
                const shopifySectionEl = doc.querySelector(`[data-section-id="${sectionId}"]`)?.closest('.shopify-section');
                if (shopifySectionEl) {
                    const productEl = shopifySectionEl.querySelector(`[data-product-handle="${handle}"]`);
                    if (productEl) {
                        const productHtmlContent = productEl.innerHTML;
                        const loaders = document.querySelectorAll('[js-warm-lead-loader]');
                        loaders.forEach((loader, index) => {
                            loader.innerHTML = `<div class="warm__lead__widget__main">${productHtmlContent}</div>`;
                            const mainItemOuter = loader.querySelector('[js-main-item-outer]');
                            if (mainItemOuter) {
                                const uniqueTargetValue = `suggested--leads--${handle}-${index}`;
                                mainItemOuter.setAttribute('data-product-target', uniqueTargetValue);
                                if( mainItemOuter.querySelectorAll(`[type="application/json"]`).length > 0 ){
                                    mainItemOuter?.querySelector(`[type="application/json"]`)?.setAttribute('id', uniqueTargetValue);
                                }                                
                            }
                        });
                    } else { 
                        console.warn(`Product with handle "${handle}" not found inside this section.`);
                    }
                }
            })
            .catch(err => {
                console.error("Drawer fetch error:", err);
            });  
        }    
    }else if (UtmPage && UtmPage.includes('/products/')) {
        const afterProducts = UtmPage.split('/products/')[1];
        const withoutQuery = afterProducts.split('?')[0];
        const withoutHash = withoutQuery.split('#')[0];
        const handle = withoutHash.split('/')[0];

        if (sessionStorage.getItem('not_interested') === 'true') {
            console.warn("Fetch skipped: User is not interested (Session Storage flag found).");
        }else{
            fetch(`/pages/page-collection-byob-2-0-ci-lead-products`)
            .then(response => response.text())
            .then(htmlString => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');
                const sectionEl = doc.querySelector('[data-section-type="collection-byob-2-0-lead"]');
                if (!sectionEl || !sectionEl.dataset.sectionId) return;
                const sectionId = sectionEl.dataset.sectionId;
                const shopifySectionEl = doc.querySelector(`[data-section-id="${sectionId}"]`)?.closest('.shopify-section');
                if (shopifySectionEl) {
                    const productEl = shopifySectionEl.querySelector(`[data-product-handle="${handle}"]`);
                    if (productEl) {
                        const productHtmlContent = productEl.innerHTML;
                        const loaders = document.querySelectorAll('[js-warm-lead-loader]');
                        loaders.forEach((loader, index) => {
                            loader.innerHTML = `<div class="warm__lead__widget__main">${productHtmlContent}</div>`;
                            const mainItemOuter = loader.querySelector('[js-main-item-outer]');
                            if (mainItemOuter) {
                                const uniqueTargetValue = `suggested--leads--${handle}-${index}`;
                                mainItemOuter.setAttribute('data-product-target', uniqueTargetValue);
                                if( mainItemOuter.querySelectorAll(`[type="application/json"]`).length > 0 ){
                                    mainItemOuter?.querySelector(`[type="application/json"]`)?.setAttribute('id', uniqueTargetValue);
                                }                                
                            }
                        });
                    } else { 
                        console.warn(`Product with handle "${handle}" not found inside this section.`);
                    }
                }
            })
            .catch(err => {
                console.error("Drawer fetch error:", err);
            });  
        }    
    }else if (currentPage && currentPage.includes('/products/')) {
        const afterProducts = currentPage.split('/products/')[1];
        const withoutQuery = afterProducts.split('?')[0];
        const withoutHash = withoutQuery.split('#')[0];
        const handle = withoutHash.split('/')[0];

        if (sessionStorage.getItem('not_interested') === 'true') {
            console.warn("Fetch skipped: User is not interested (Session Storage flag found).");
        }else{
            fetch(`/pages/page-collection-byob-2-0-ci-lead-products`)
            .then(response => response.text())
            .then(htmlString => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');
                const sectionEl = doc.querySelector('[data-section-type="collection-byob-2-0-lead"]');
                if (!sectionEl || !sectionEl.dataset.sectionId) return;
                const sectionId = sectionEl.dataset.sectionId;
                const shopifySectionEl = doc.querySelector(`[data-section-id="${sectionId}"]`)?.closest('.shopify-section');
                if (shopifySectionEl) {
                    const productEl = shopifySectionEl.querySelector(`[data-product-handle="${handle}"]`);
                    if (productEl) {
                        const productHtmlContent = productEl.innerHTML;
                        const loaders = document.querySelectorAll('[js-warm-lead-loader]');
                        loaders.forEach((loader, index) => {
                            loader.innerHTML = `<div class="warm__lead__widget__main">${productHtmlContent}</div>`;
                            const mainItemOuter = loader.querySelector('[js-main-item-outer]');
                            if (mainItemOuter) {
                                const uniqueTargetValue = `suggested--leads--${handle}-${index}`;
                                mainItemOuter.setAttribute('data-product-target', uniqueTargetValue);
                                if( mainItemOuter.querySelectorAll(`[type="application/json"]`).length > 0 ){
                                    mainItemOuter?.querySelector(`[type="application/json"]`)?.setAttribute('id', uniqueTargetValue);
                                }                                
                            }
                        });
                    } else { 
                        console.warn(`Product with handle "${handle}" not found inside this section.`);
                    }
                }
            })
            .catch(err => {
                console.error("Drawer fetch error:", err);
            });  
        }    
    } else {
        console.warn('Previous page not contains /products');
    }

    document.addEventListener('click', function(event) {
        const destroyBtn = event.target.closest('[js-destroy-warm-lead]');
        if (destroyBtn) {
            sessionStorage.setItem('not_interested', 'true');
            document.querySelectorAll('[js-warm-lead-loader]').forEach(loader => {
                loader.innerHTML = ''; 
            });
        }
    });    

    const heroMediaSlider = document?.querySelector('.collection__byob_twv__banner_nt.swiper');
    if (heroMediaSlider) {
        const customPagination = document.querySelector('.twv__banner__custom__pagination');
        const customNavPagOuter = document.querySelector(`.twv__banner__paginations`);
        let isPaused = false;

        function buildDots(count) {
            customPagination.innerHTML = '';
            for (let i = 0; i < count; i++) {
                const dot = document.createElement('div');
                dot.classList.add('dot');
                dot.style.setProperty('--autoplay-delay', AUTOPLAY_DELAY + 'ms');
                dot.addEventListener('click', () => swiperInstance.slideToLoop(i));
                customPagination.appendChild(dot);
            }
        }

        function setActiveDot(index, fillFull = false) {
            customPagination.querySelectorAll('.dot').forEach(dot => {
                dot.classList.remove('active', 'is-paused', 'is-filled');
                void dot.offsetWidth;
            });
            const activeDot = customPagination.querySelectorAll('.dot')[index];
            if (!activeDot) return;
            activeDot.classList.add('active');
            if (fillFull) {
                activeDot.classList.add('is-filled');
            }
        }

        const heroMediaSliderConfig = {
            spaceBetween: 0, slidesPerView: 1, grabCursor: true, speed: 300,
            navigation: {
                nextEl: heroMediaSlider.querySelector('.swiper-button-next'),
                prevEl: heroMediaSlider.querySelector('.swiper-button-prev')
            },
            autoplay: { delay: AUTOPLAY_DELAY, disableOnInteraction: true },
            loop: true,
            on: {
                autoplayStop() {
                    isPaused = true;
                    const activeDot = customPagination.querySelector('.dot.active');
                    if (activeDot) {
                        activeDot.classList.add('is-paused');
                    }
                },
                autoplayStart() {
                    isPaused = false;
                    const activeDot = customPagination.querySelector('.dot.active');
                    if (activeDot) {
                        activeDot.classList.remove('is-paused');
                    }
                },
                slideChangeTransitionEnd(swiper) {
                    setActiveDot(swiper.realIndex, isPaused);
                }
            }
        };

        if (!isIOS) {
            heroMediaSliderConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        }

        const swiperInstance = new Swiper(heroMediaSlider, heroMediaSliderConfig);
        const totalSlides = swiperInstance.slides.filter(
            s => !s.classList.contains('swiper-slide-duplicate')
        ).length;

        buildDots(totalSlides);
        setActiveDot(swiperInstance.realIndex);

        if (totalSlides <= 1) {
            if (customNavPagOuter) customNavPagOuter.classList.add(`hidden`);
            swiperInstance.autoplay.stop();
        }
    }

    const reviewsScrollarEl = document.querySelector('.page__reviews__swp.swiper');
    if (reviewsScrollarEl) {
        const reviewsScrollarConfig = { 
            spaceBetween: 12, slidesPerView: 'auto', grabCursor: true,
            navigation: { nextEl: reviewsScrollarEl.closest('.page__reviews__container').querySelector('.swiper-button-next'), prevEl: reviewsScrollarEl.closest('.page__reviews__container').querySelector('.swiper-button-prev')},
            cssMode: isIOS && isMobile ? true : false,
         };
        reviewsScrollarConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        reviewsScrollarConfig.freeMode = true;
        new Swiper(reviewsScrollarEl, reviewsScrollarConfig);
    } 

    if ( document.querySelectorAll('.customer__testimonial_swipe').length > 0 ){
        const swiperElementCardSwp = document.querySelector('.customer__testimonial_swipe.swiper');
        if (swiperElementCardSwp) {
            const config = {
                spaceBetween: 12,allowTouchMove: true,slidesPerView: 'auto',grabCursor: true,keyboard: { enabled: true },
                navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'}
            };
            if (!isIOS) {
                config.freeMode = true;
                config.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
            }
            window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
        }  
    }

    if( document.querySelectorAll('.squeeze_scroller_item').length > 0 ){
        const scrollingContent = document.getElementById("scrollingContent");
        scrollingContent.innerHTML += scrollingContent.innerHTML;
        let x = 0;
        let scrollSpeed = 0.4;
        let isPaused = false;
        function animate() {
            if (!isPaused) {
            x -= scrollSpeed;
            if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
                x = 0;
            }
            scrollingContent.style.transform = `translateX(${x}px)`;
            }
            requestAnimationFrame(animate);
        }
        document.querySelector(".squeeze_scroller_main").addEventListener("mouseenter", () => isPaused = true);
        document.querySelector(".squeeze_scroller_main").addEventListener("mouseleave", () => isPaused = false);
        animate();  
    }  

    const bundleScripts = document.querySelectorAll('script[type="application/json"][id*="product_level"]');
    if( bundleScripts.length > 0 ){
        bundleScripts.forEach(script => {
            try {
                const items = JSON.parse(script.textContent);
                if (Array.isArray(items)) {
                    items.forEach(item => {
                        if (item.imageUrl) {
                            const imgCache = new Image();
                            imgCache.src = item.imageUrl;
                        }
                    });
                }
            } catch (e) {
                console.error("Preload caching skipped for item:", e);
            }
        });    
    }

    document?.querySelectorAll('a[href^="#"]').forEach(link => {
        link?.addEventListener('click', function (e) {
            const hash = this.getAttribute('href').slice(1);
            const target = document.querySelector(`[data-target-el="${hash}"]`);
            if (target) {
                e.preventDefault();
                const offset = document.querySelector(`.section-header`).clientHeight + document.querySelector('.this__sticky__nav__mn').clientHeight + 20;
                const top = target.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        });
    });    

    const updCommBuyButtonWMsg = () => {
        const drawerContainer = document.querySelector(`[js-drawer-communication-html]`);
        if (!drawerContainer) return;

        const sumQtyOf = (nodeList) => Array.from(nodeList).reduce((sum, el) => {
            return sum + (parseInt(el.dataset.mappedQuantity, 10) || 1);
        }, 0);

        const eligibleInCart = sumQtyOf(drawerContainer.querySelectorAll(`[data-onetime-addons="false"]`));
        const addonsInCart = sumQtyOf(drawerContainer.querySelectorAll(`[data-onetime-addons="true"]`));
        const hasAddonsInCart = addonsInCart > 0;
        
        const totalItemsInCart = eligibleInCart + addonsInCart;

        const mainButton = document.querySelector(`[js-main-button]`);
        const mainButtonText = mainButton?.querySelector(`[js-main-button-text]`);
        const limitItemsElements = document.querySelectorAll(`[js-drawer-limit-items]`);
        const totalCountElements = document.querySelectorAll(`[js-cm-count-items-total]`);
        const warningNotice = document.querySelector(`[js-drawer-notice--warn]`);
        const carekitItems = document.querySelectorAll(`.addons___carekit_item`);

        totalCountElements?.forEach((el) => { 
            el.hasAttribute(`has-selected`) 
                ? (el.textContent = `${totalItemsInCart} Selected`) 
                : (el.textContent = totalItemsInCart); 
        });

        if (eligibleInCart >= 3) {
            if (warningNotice) warningNotice.classList.add('hidden');
            carekitItems?.forEach((item) => {
                item.classList.remove('disabled_meanwhile');
            });

            if (mainButtonText) mainButtonText.textContent = `Add to Cart (${totalItemsInCart} items)`;
            if (mainButton) mainButton.disabled = false;
            
            limitItemsElements?.forEach((el) => { 
                if (!el.hasAttribute(`js-mb-drawer-limit-items`)) { 
                    el.classList.remove('hidden'); 
                    el.textContent = `Add items +`;
                } 
            });
            let NoticeBadge = document?.querySelector(`.addons___carekit_header_badge.notice__badge`);
            Object.assign(NoticeBadge.style, { opacity: '0', visibility: 'hidden', pointerEvents: 'none' });            
        } else {
            carekitItems?.forEach((item) => {
                item.classList.add('disabled_meanwhile');
            });
            
            if (warningNotice) {
                if (hasAddonsInCart) {
                    warningNotice.classList.remove('hidden');
                } else {
                    warningNotice.classList.add('hidden');
                }
            }

            const itemsNeeded = 3 - eligibleInCart;
            const itemWord = itemsNeeded === 1 ? 'item' : 'items';
            
            const messageText = hasAddonsInCart 
                ? `Add ${itemsNeeded} eligible ${itemWord} to checkout`
                : `Add ${itemsNeeded} ${itemWord} to checkout`;
            
            if (mainButtonText) mainButtonText.textContent = messageText;
            if (mainButton) mainButton.disabled = true;
            
            limitItemsElements?.forEach((el) => { 
                el.classList.remove('hidden', 'highlight'); 
                el.textContent = `${messageText} +`;
            });
            let NoticeBadge = document?.querySelector(`.addons___carekit_header_badge.notice__badge`);
            Object.assign(NoticeBadge.style, { opacity: '', visibility: '', pointerEvents: '' });
        }
    };

    const updateDrawerLineQtyUI = (lineEl, qty) => {
        const qtyValueEl = lineEl.querySelector('[js-cm-drawer-qty-value]');
        if (qtyValueEl) qtyValueEl.textContent = qty;

        const removeBtn = lineEl.querySelector('[js-cm-drawer-remove]');
        const minusBtn = lineEl.querySelector('[js-cm-drawer-minus]');

        if (qty > 1) {
            removeBtn?.classList.add('hidden');
            minusBtn?.classList.remove('hidden');
        } else {
            removeBtn?.classList.remove('hidden');
            minusBtn?.classList.add('hidden');
        }
    };

    const buildItemKey = (mappedTarget, variantId, dynamicBoxId) => {
        return `${variantId || ''}`;
    };

    const updCommItemAdd = (targetEl) => {
        let mapChildBundle = targetEl.dataset.productTarget;
        const scriptElement = targetEl.querySelector(`[id="${mapChildBundle}"]`);
        const isOneTime = document?.querySelector('input[name="purchaseType"]:checked')?.value === 'purchaseTypeOneTime';
        const communicationDrawer = document.querySelector('[js-drawer-communication-html]');
        if (!communicationDrawer) return;

        const addOrIncrementUnit = (unitData, unitQty, isFromBundle) => {
            const itemKey = buildItemKey(targetEl?.dataset?.productTarget, unitData.variantId, unitData.dynamicBoxid);
            const existingLine = communicationDrawer.querySelector(`[data-item-key="${itemKey}"]`);

            if (existingLine) {
                const newQty = (parseInt(existingLine.dataset.mappedQuantity, 10) || 0) + unitQty;
                existingLine.dataset.mappedQuantity = newQty;
                updateDrawerLineQtyUI(existingLine, newQty);
                
                if (isFromBundle) {
                    existingLine.dataset.mappedTarget = targetEl.dataset.productTarget;
                    existingLine.dataset.isFromBundle = "true";
                }
            } else {
                const html = buildItemHtml(targetEl, Object.assign({}, unitData, { quantity: unitQty, itemKey }));
                if (html) {
                    communicationDrawer.insertAdjacentHTML('beforeend', html);
                    const addedLine = communicationDrawer.querySelector(`[data-item-key="${itemKey}"]`);
                    if (addedLine) {
                        if (isFromBundle) {
                            addedLine.dataset.mappedTarget = targetEl.dataset.productTarget;
                            addedLine.dataset.isFromBundle = "true";
                        } else {
                            addedLine.dataset.mappedTarget = targetEl?.dataset?.productTarget || 'none';
                            addedLine.dataset.isFromBundle = "false";
                        }
                    }
                }
            }
        };

        if (scriptElement) {
            try {
                const bundleItems = JSON.parse(scriptElement.textContent);
                bundleItems.forEach(item => {
                    let displayPrice = isOneTime ? item.priceFormatted : (item.SubscribePriceFormatted || item.priceFormatted);
                    let displayCPrice = isOneTime ? item.compareAtPriceFormatted : (item.SubscribeCompareAtPriceFormatted || item.compareAtPriceFormatted);
                    let loopCount = parseInt(item.quantity) || 1;

                    addOrIncrementUnit({
                        title: item.productTitle,
                        price: item.priceFormatted,
                        subPrice: item.SubscribePriceFormatted || '',
                        cprice: item.compareAtPriceFormatted,
                        subCprice: item.SubscribeCompareAtPriceFormatted || '',
                        variantId: item.id,
                        imageUrl: item.imageUrl,
                        displayPrice: displayPrice,
                        displayCPrice: displayCPrice,
                        serving: item.serving,
                        selling_plan_id: item.selling_plan_id,
                        dynamicBoxid: item.dynamic_box_id
                    }, loopCount, true);
                });
            } catch (e) {
                console.error("Error parsing product bundle JSON:", e);
            }
        } else {
            let displayPrice = isOneTime ? targetEl?.dataset?.productPrice : (targetEl?.dataset?.productsubscripitonPrice || targetEl?.dataset?.productPrice);
            let displayCPrice = isOneTime ? targetEl?.dataset?.productCprice : (targetEl?.dataset?.productsubscripitonCprice || targetEl?.dataset?.productCprice);

            addOrIncrementUnit({
                title: targetEl?.dataset?.productTitle,
                price: targetEl?.dataset?.productPrice,
                subPrice: targetEl?.dataset?.productsubscripitonPrice || '',
                cprice: targetEl?.dataset?.productCprice,
                subCprice: targetEl?.dataset?.productsubscripitonCprice || '',
                variantId: targetEl?.dataset?.productVariantId,
                imageUrl: targetEl?.dataset?.productImage,
                displayPrice: displayPrice,
                displayCPrice: displayCPrice
            }, 1, false);
        }

        updCommBuyButtonWMsg();
        SummaryDrawerMobileAnimation();
        updCommPriceTotal();
    }

    const buildItemHtml = (targetEl, data) => {
        const cleanPrice = (priceStr) => {
            if (!priceStr) return 0;
            return parseFloat(priceStr.replace(/[^0-9.-]+/g, "")) || 0;
        };
        const numericPrice = cleanPrice(data.displayPrice);
        const numericCPrice = cleanPrice(data.displayCPrice);
        const numericSubPrice = cleanPrice(data.subPrice);
        const isOneTime = document?.querySelector('input[name="purchaseType"]:checked')?.value === 'purchaseTypeOneTime';

        let shouldShowComparePrice = false;
        let fallbackComparePrice = data.displayCPrice;

        if (!isOneTime) {
            if (numericCPrice > 0 && numericCPrice > numericPrice && numericCPrice > numericSubPrice) {
                shouldShowComparePrice = true;
            } else {
                shouldShowComparePrice = true;
                fallbackComparePrice = data.price;
            }
        } else {
            if (numericCPrice > numericPrice) {
                shouldShowComparePrice = true;
            } else {
                shouldShowComparePrice = false;
            }
        }

        targetEl?.hasAttribute(`js-has-onetime-only`) ? (shouldShowComparePrice = false) : (shouldShowComparePrice = shouldShowComparePrice );

        const cPriceClass = shouldShowComparePrice ? "" : "hidden";
        const PriceClass = shouldShowComparePrice ? "" : "normal__price__color";
        const displayServingText = data.serving || targetEl?.dataset?.servingProcess || '';
        const sellingPlanIdMap = data.selling_plan_id || targetEl?.dataset?.productSellingId || '';
        const dynamicBoxIdMap = data.dynamicBoxid || targetEl?.dataset?.productDynamicboxId || '';
        const quantity = data.quantity || 1;
        const itemKey = data.itemKey || buildItemKey(targetEl?.dataset?.productTarget, data.variantId, dynamicBoxIdMap);

        return `
        <div class="dproute__product__item" js-cm-drawer-outer
            data-item-key="${itemKey}"
            data-mapped-quantity="${quantity}"
            data-onetime-addons="${ targetEl?.hasAttribute(`js-has-onetime-only`) ? `true` : `false` }" 
            data-restrictions-has="${ targetEl?.hasAttribute(`js-restrictions-for-adding`) ? `true` : `false` }"
            data-accepts-onetime="${ targetEl?.hasAttribute(`js-has-onetime-only`) ? `true` : `false` }"  
            data-mapped-target="${targetEl?.dataset?.productTarget}"
            data-mapped-handle="${data.title}"
            data-mapped-price="${data.price}" 
            data-mapped-subscription-price="${data.subPrice}"
            data-mapped-cprice="${data.cprice}" 
            data-mapped-subscription-cprice="${fallbackComparePrice}"
            data-mapped-variant-id="${data.variantId}"
            data-mapped-selling-id="${sellingPlanIdMap}"
            data-mapped-dynamicbox-id="${dynamicBoxIdMap}">
            
            <div class="dproute_image_drawer"><img src="${data.imageUrl}"></div>
            <div class="dproute_content_drawer">
                <div class="dproute_title_priceContainer">
                    <div class="dproute_title_drawer">${data.title}</div>
                    <div class="dproute_serving_drawer">${displayServingText}</div>
                    <div class="dproute__form-title ${ (targetEl?.hasAttribute(`js-has-onetime-only`) || targetEl?.hasAttribute(`js-main-bundle-group`)) ? `hidden` : ` ` }">
                        <div class="dproute_bannerKeyPoints">
                            ${(() => {
                                const offers = targetEl?.dataset?.productOffer ? targetEl.dataset.productOffer.split('|').filter(o => o.trim() !== '') : [];
                                if (!offers.length) return '';
                                return offers.map(offer => `
                                    <div class="dproute_bannerKeyPoint">
                                        <span class="KyIcon__dproute">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="m.467 6.41 4.46 4.573 7.673-8.4" stroke="#398200" stroke-width="1.167"></path></svg>
                                        </span>
                                        <span class="KyPoint__dproute">${offer.trim()}</span>
                                    </div>
                                `).join('');
                            })()}
                        </div>
                    </div>
                    ${ targetEl?.hasAttribute(`js-has-onetime-only`) ? `<div class="has__onetime__only"><span>Add-On Item</span></div>` : ` ` }                    
                </div>
                <div class="dproute_servingRemoveContainer">
                    <div class="dproute_price_drawerMn">
                        <span class="dproute_price_drawer ${PriceClass}" js-cm-drawer-price>${data.displayPrice}</span>
                        <span class="dproute_cprice_drawer ${cPriceClass}" js-cm-drawer-cprice>${fallbackComparePrice}</span>
                    </div>                
                    <div class="dproute_qty_drawer" js-cm-drawer-qty>
                        <div class="dproute_qty_btn dproute_qty_remove ${quantity > 1 ? 'hidden' : ''}" js-cm-drawer-remove>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"> <path d="M5.55156 17.3125C5.21641 17.3125 4.92949 17.1932 4.69082 16.9545C4.45215 16.7158 4.33281 16.4289 4.33281 16.0937V4.51562H3.5V3.29688H7.31875V2.6875H12.6813V3.29688H16.5V4.51562H15.6672V16.0937C15.6672 16.4187 15.5453 16.7031 15.3016 16.9469C15.0578 17.1906 14.7734 17.3125 14.4484 17.3125H5.55156ZM14.4484 4.51562H5.55156V16.0937H14.4484V4.51562ZM7.70469 14.3469H8.92344V6.24219H7.70469V14.3469ZM11.0766 14.3469H12.2953V6.24219H11.0766V14.3469Z" fill="#BBBCBC"></path> </svg>
                        </div>
                        <div class="dproute_qty_btn dproute_qty_minus ${quantity > 1 ? '' : 'hidden'}" js-cm-drawer-minus aria-label="Decrease quantity">
                            <span class="dproute_qty_btn_glyph">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"> <path d="M4.26953 10.5618V9.41602H15.7279V10.5618H4.26953Z" fill="#BBBCBC"></path> </svg>
                            </span>
                        </div>
                        <div class="dproute_qty_value" js-cm-drawer-qty-value>${quantity}</div>
                        <div class="dproute_qty_btn dproute_qty_plus" js-cm-drawer-plus aria-label="Increase quantity">
                            <span class="dproute_qty_btn_glyph">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"> <path d="M9.42578 10.5618H4.26953V9.41602H9.42578V4.25977H10.5716V9.41602H15.7279V10.5618H10.5716V15.7181H9.42578V10.5618Z" fill="#BBBCBC"></path> </svg>
                            </span>
                        </div>
                    </div>
                </div>                
            </div>
        </div>`;
    }

    const updCommItemRemove = (targetEl, fromDrawer) => {
        const drawerContainer = document.querySelector('[js-drawer-communication-html]');
        if (!drawerContainer) return;

        if (fromDrawer) {
            const mappedTarget = targetEl.dataset.mappedTarget;
            const currentQty = parseInt(targetEl.dataset.mappedQuantity, 10) || 1;
            const targetVariantId = targetEl.dataset.mappedVariantId;

            if (currentQty > 1) {
                const newQty = currentQty - 1;
                targetEl.dataset.mappedQuantity = newQty;
                updateDrawerLineQtyUI(targetEl, newQty);
            } else {
                targetEl.remove();
            }

            let dashboardItem = document.querySelector(`[data-product-target="${mappedTarget}"]`);
            const singleDashboardItem = document.querySelector(`[data-product-variant-id="${targetVariantId}"]:not([data-product-target*="bundle"])`) || 
                                        document.querySelector(`[data-product-variant-id="${targetVariantId}"]`);

            if (dashboardItem) {
                const isBundle = !!dashboardItem.querySelector(`[id="${mappedTarget}"]`);
                const qtyInput = dashboardItem.querySelector('[js-button-confiq-input]');

                if (isBundle) {
                    const remainingLinesForTarget = drawerContainer.querySelectorAll(`[data-mapped-target="${mappedTarget}"]`);
                    
                    if (remainingLinesForTarget.length === 0) {
                        dashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
                        if (qtyInput) qtyInput.innerHTML = 1;
                        dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                        dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                        
                        if (singleDashboardItem && singleDashboardItem !== dashboardItem) {
                            const sQtyInput = singleDashboardItem.querySelector('[js-button-confiq-input]');
                            singleDashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
                            if (sQtyInput) sQtyInput.innerHTML = 1;
                            singleDashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                            singleDashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                        }
                    } else {
                        const scriptElement = dashboardItem.querySelector(`[id="${mappedTarget}"]`);
                        let maxBundleGroupsFound = 0;
                        let baseQtyPerGroupForThisVariant = 1;
                        const currentBundleQtyCounter = parseInt(qtyInput.textContent, 10) || 1;
                        
                        try {
                            const bundleItems = JSON.parse(scriptElement.textContent);
                            bundleItems.forEach(bItem => {
                                const bVariantId = bItem.id;
                                const baseQtyPerGroup = parseInt(bItem.quantity, 10) || 1;
                                if (bVariantId == targetVariantId) {
                                    baseQtyPerGroupForThisVariant = baseQtyPerGroup;
                                }
                                
                                const drawerItemMatch = Array.from(remainingLinesForTarget).find(line => line.dataset.mappedVariantId == bVariantId);
                                if (drawerItemMatch) {
                                    const currentDrawerQty = parseInt(drawerItemMatch.dataset.mappedQuantity, 10) || 0;
                                    const cappedDrawerQty = Math.min(currentDrawerQty, currentBundleQtyCounter * baseQtyPerGroup);
                                    const calculatedGroups = Math.ceil(cappedDrawerQty / baseQtyPerGroup);
                                    if (calculatedGroups > maxBundleGroupsFound) {
                                        maxBundleGroupsFound = calculatedGroups;
                                    }
                                }
                            });
                        } catch(e){}

                        const finalDrawerQtyAfterMinus = currentQty > 1 ? currentQty - 1 : 0; 
                        const bundleRequiredPortion = currentBundleQtyCounter * baseQtyPerGroupForThisVariant;
                        
                        if (finalDrawerQtyAfterMinus >= bundleRequiredPortion) {
                            if (singleDashboardItem) {
                                const sQtyInput = singleDashboardItem.querySelector('[js-button-confiq-input]');
                                if (sQtyInput) {
                                    const singleCalculatedQty = finalDrawerQtyAfterMinus - bundleRequiredPortion;
                                    if (singleCalculatedQty <= 0) {
                                        singleDashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
                                        sQtyInput.innerHTML = 1;
                                        singleDashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                                        singleDashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                                    } else {
                                        singleDashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.add('active');
                                        sQtyInput.innerHTML = singleCalculatedQty;
                                        if (singleCalculatedQty === 1) {
                                            singleDashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                                            singleDashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                                        } else {
                                            singleDashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.add('hidden');
                                            singleDashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.remove('hidden');
                                        }
                                    }
                                }
                            }
                        } else {
                            if (maxBundleGroupsFound <= 0) {
                                dashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
                                if (qtyInput) qtyInput.innerHTML = 1;
                                dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                                dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                            } else {
                                if (qtyInput) qtyInput.innerHTML = maxBundleGroupsFound;
                                if (maxBundleGroupsFound === 1) {
                                    dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                                    dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                                } else {
                                    dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.add('hidden');
                                    dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.remove('hidden');
                                }
                            }

                            if (singleDashboardItem && singleDashboardItem !== dashboardItem) {
                                singleDashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
                                const sQtyInput = singleDashboardItem.querySelector('[js-button-confiq-input]');
                                if (sQtyInput) sQtyInput.innerHTML = 1;
                                singleDashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                                singleDashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                            }
                        }
                    }
                } else {
                    const remainingSingleLines = drawerContainer.querySelectorAll(`[data-mapped-variant-id="${targetVariantId}"]`);
                    let totalSingleQtyRemaining = 0;
                    remainingSingleLines.forEach(l => {
                        totalSingleQtyRemaining += (parseInt(l.dataset.mappedQuantity, 10) || 0);
                    });

                    if (totalSingleQtyRemaining <= 0) {
                        dashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
                        if (qtyInput) qtyInput.innerHTML = 1;
                        dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                        dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                    } else {
                        if (qtyInput) qtyInput.innerHTML = totalSingleQtyRemaining;
                        if (totalSingleQtyRemaining === 1) {
                            dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                            dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                        } else {
                            dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.add('hidden');
                            dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.remove('hidden');
                        }
                    }
                }
            }
        } else {
            const productTarget = targetEl.dataset.productTarget;
            const scriptElement = targetEl.querySelector(`[id="${productTarget}"]`);
            const configOuter = targetEl.querySelector('[js-button-confiq-outer]');
            const clearEntireBundleGroup = configOuter ? !configOuter.classList.contains('active') : false;
            
            const qtyInput = targetEl.querySelector('[js-button-confiq-input]');
            const dashboardQty = parseInt(qtyInput ? (qtyInput.textContent || "1") : "1", 10);

            if (scriptElement) {
                try {
                    const bundleItems = JSON.parse(scriptElement.textContent);

                    bundleItems.forEach(item => {
                        const line = drawerContainer.querySelector(`[data-mapped-variant-id="${item.id}"]`);
                        if (!line) return;
                        const currentQty = parseInt(line.dataset.mappedQuantity, 10) || 0;
                        const baseQtyPerGroup = parseInt(item.quantity, 10) || 1;
                        const qtyToRemove = clearEntireBundleGroup ? (baseQtyPerGroup * dashboardQty) : baseQtyPerGroup;
                        const newQty = currentQty - qtyToRemove;
                        if (newQty > 0) {
                            line.dataset.mappedQuantity = newQty;
                            updateDrawerLineQtyUI(line, newQty);
                        } else {
                            line.remove();
                        }
                    });
                } catch (e) {
                    console.error("Error on dashboard minus click integration:", e);
                }
            } else {
                const targetVariantId = targetEl.dataset.productVariantId;
                const line = drawerContainer.querySelector(`[data-mapped-variant-id="${targetVariantId}"]`);
                
                if (line) {
                    const currentQty = parseInt(line.dataset.mappedQuantity, 10) || 1;
                    const qtyToRemove = clearEntireBundleGroup ? dashboardQty : 1;
                    const newQty = currentQty - qtyToRemove;

                    if (newQty > 0) {
                        line.dataset.mappedQuantity = newQty;
                        updateDrawerLineQtyUI(line, newQty);
                    } else {
                        line.remove();
                    }
                }
            }
        }

        if (typeof updCommBuyButtonWMsg === 'function') updCommBuyButtonWMsg();
        if (typeof updCommPriceTotal === 'function') updCommPriceTotal();
        
        if (drawerContainer && drawerContainer.querySelectorAll('[js-cm-drawer-outer]').length === 0) {
            if (typeof clearAllCommHTMLAndResetDashboard === 'function') clearAllCommHTMLAndResetDashboard();
        }
    };

    const clearAllCommHTMLAndResetDashboard = () => {
        const drawerContainer = document.querySelector('[js-drawer-communication-html]');
        if (!drawerContainer) return;
        drawerContainer.innerHTML = '';
        const activeDashboardItems = document.querySelectorAll('[data-product-target]');
        activeDashboardItems.forEach((dashboardItem) => {
            dashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
            const qtyInput = dashboardItem.querySelector('[js-button-confiq-input]');
            if (qtyInput) {
                qtyInput.innerHTML = 1;
            }
            dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
            dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
        });

        if( document.querySelector(`[js-cm-main-outer-stepper]`).querySelectorAll(`.for__step__one`).length > 0 ){
            document.querySelector(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__second`).classList.remove('active');
            document.querySelector(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__one`).classList.remove('hidden');
            document?.querySelector(`.twv__split___renders__drawer`)?.classList?.remove(`stepper__procced`);
        }

        updCommBuyButtonWMsg();
        updCommPriceTotal();
    };


    const updPriceAllOverPSelBased = (PurchaseType)=>{
        if( PurchaseType == 'purchaseTypeOneTime' ){
            document.querySelectorAll(`[js-main-item-outer]`).forEach((el) => {
                let targetElProduct = el.dataset.productTarget;
                let oneTimePrice = el.dataset.productPrice;
                let oneTimeCPrice = el.dataset.productCprice;
                if( el?.querySelector(`[js-item-product-price]`) || el?.querySelector(`[js-item-product-cprice]`) ){
                    el.querySelector(`[js-item-product-price]`).textContent = oneTimePrice;
                    el.querySelector(`[js-item-product-cprice]`).textContent = oneTimeCPrice;
                    const priceVal  = parseFloat(oneTimePrice.replace(/[^0-9.]/g, ''));
                    const cPriceVal = parseFloat(oneTimeCPrice.replace(/[^0-9.]/g, ''));
                    if (cPriceVal > priceVal) {
                        el?.querySelector(`[js-item-product-cprice]`)?.classList?.remove('hidden');
                        el?.querySelector(`[js-item-product-price]`)?.classList?.remove('normal__price__color');
                    } else {
                        el?.querySelector(`[js-item-product-cprice]`)?.classList?.add('hidden');
                        el?.querySelector(`[js-item-product-price]`)?.classList?.add('normal__price__color');
                    }
                    document?.querySelectorAll(`[data-mapped-target="${targetElProduct}"]`)?.forEach((dEl) => {
                        dEl.querySelector(`[js-cm-drawer-price]`).textContent = dEl.dataset.mappedPrice;
                        dEl.querySelector(`[js-cm-drawer-cprice]`).textContent = dEl.dataset.mappedCprice;
                        if (cPriceVal > priceVal) {
                            dEl?.querySelector(`[js-cm-drawer-cprice]`)?.classList?.remove('hidden');
                            dEl?.querySelector(`[js-cm-drawer-price]`)?.classList?.remove('normal__price__color');
                        } else {
                            dEl?.querySelector(`[js-cm-drawer-cprice]`)?.classList?.add('hidden');
                            dEl?.querySelector(`[js-cm-drawer-price]`)?.classList?.add('normal__price__color');
                        }                    
                    });
                }
            });          
        }else{
            document.querySelectorAll(`[js-main-item-outer]`).forEach((el) => {
                let targetElProduct = el.dataset.productTarget;
                let SubscribePrice = el.dataset.productsubscripitonPrice;
                let SubscribeCPrice = el.dataset.productsubscripitonCprice;
                if( el?.querySelector(`[js-item-product-price]`) || el?.querySelector(`[js-item-product-cprice]`) ){
                    el.querySelector(`[js-item-product-price]`).textContent = SubscribePrice;
                    el.querySelector(`[js-item-product-cprice]`).textContent = SubscribeCPrice;
                    const priceVal  = parseFloat(SubscribePrice.replace(/[^0-9.]/g, ''));
                    const cPriceVal = parseFloat(SubscribeCPrice.replace(/[^0-9.]/g, ''));
                    if (cPriceVal > priceVal) {
                        el?.querySelector(`[js-item-product-cprice]`)?.classList?.remove('hidden');
                        el?.querySelector(`[js-item-product-price]`)?.classList?.remove('normal__price__color');
                    } else {
                        el?.querySelector(`[js-item-product-cprice]`)?.classList?.add('hidden');
                        el?.querySelector(`[js-item-product-price]`)?.classList?.add('normal__price__color');
                    }
                    document?.querySelectorAll(`[data-mapped-target="${targetElProduct}"]`)?.forEach((dEl) => {
                        dEl.querySelector(`[js-cm-drawer-price]`).textContent = dEl.dataset.mappedSubscriptionPrice;
                        dEl.querySelector(`[js-cm-drawer-cprice]`).textContent = dEl.dataset.mappedSubscriptionCprice;
                        if (cPriceVal > priceVal) {
                            dEl?.querySelector(`[js-cm-drawer-cprice]`)?.classList?.remove('hidden');
                            dEl?.querySelector(`[js-cm-drawer-price]`)?.classList?.remove('normal__price__color');
                        } else {
                            dEl?.querySelector(`[js-cm-drawer-cprice]`)?.classList?.add('hidden');
                            dEl?.querySelector(`[js-cm-drawer-price]`)?.classList?.add('normal__price__color');
                        }                    
                    });
                }
            });            
        }
    }

    const updCommPriceTotal = () => {
        let totalSubscribePrice = 0;
        let totalSubscribeCprice = 0;

        document?.querySelectorAll(`[js-cm-drawer-outer]`)?.forEach((item) => {
            let itemQty = parseInt(item.dataset.mappedQuantity, 10) || 1;
            let itemSubscribePrice    = item.dataset.mappedSubscriptionPrice;
            let itemSubscribeCprice   = item.dataset.mappedSubscriptionCprice;
            const parsePrice = (val) => {
                if (!val) return 0;
                return parseFloat(val.toString().replace(/[^0-9.]/g, '')) || 0;
            };
            totalSubscribePrice  += parsePrice(itemSubscribePrice) * itemQty;
            totalSubscribeCprice += parsePrice(itemSubscribeCprice) * itemQty;
        });

        const fmt = (val) => val === 0 ? '' : `$${val.toFixed(2)}`;

        if (document?.querySelector(`[js-subscribeprice]`)) {
            document.querySelector(`[js-subscribeprice]`).textContent  = fmt(totalSubscribePrice);
            document.querySelector(`[js-subscribecprice]`).textContent = fmt(totalSubscribeCprice);
            if (totalSubscribeCprice > totalSubscribePrice) {
                document?.querySelector(`[js-subscribeprice]`)?.classList.add(`this__cprice`);
                document?.querySelector(`[js-subscribecprice]`)?.classList.remove(`hidden`);
            } else {
                document?.querySelector(`[js-subscribeprice]`)?.classList.remove(`this__cprice`);
                document?.querySelector(`[js-subscribecprice]`)?.classList.add(`hidden`);
            }
        }
        updCommProgressBar();
        updCmDrawerUpsellMessage();
    };

    const updCommProgressBar = ()=>{
        const checkedPurchaseType = document.querySelector(`input[name="purchaseType"]:checked`)?.value;
        const priceSelectorOneTime = `[js-onetimeprice]`;
        const priceSelectorSubscribe = `[js-subscribeprice]`;
        const priceSelector = `[js-subscribeprice]`;
        const priceText = document.querySelector(priceSelector)?.textContent?.trim();
        const currentPrice = priceText ? parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0 : 0;
        const priceTextOneTime = document.querySelector(priceSelectorOneTime)?.textContent?.trim();
        const currentPriceOneTime = priceTextOneTime ? parseFloat(priceTextOneTime.replace(/[^0-9.]/g, '')) || 0 : 0;
        const priceTextSubscribe = document.querySelector(priceSelectorSubscribe)?.textContent?.trim();
        const currentPriceSubscribe = priceTextSubscribe ? parseFloat(priceTextSubscribe.replace(/[^0-9.]/g, '')) || 0 : 0;                
        document?.querySelectorAll(`[js-cm-progress-bar]`)?.forEach((bar) => {
            const threshold = parseFloat(bar.dataset.thresholdBar) || 0;
            if (!currentPrice || !threshold) {
                checkedPurchaseType === 'purchaseTypeOneTime' ?
                ( bar.querySelector(`[js-progress-cm-width]`).style.width = '0%',bar.querySelector(`[js-cm-bar-ongoing]`).classList.remove(`hidden`),bar.querySelector(`[js-cm-bar-success]`).classList.add(`hidden`),bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = bar.querySelector(`[js-cm-bar-ongoing]`).dataset.priceMessage ):
                ( bar.hasAttribute(`js-with-drawer-shipping`) ? ( bar.querySelector(`[js-progress-cm-width]`).style.width = '100%',bar.querySelector(`[js-cm-bar-ongoing]`).classList.add(`hidden`),bar.querySelector(`[js-cm-bar-success]`).classList.remove(`hidden`) ) : (bar.querySelector(`[js-progress-cm-width]`).style.width = '0%',bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = bar.querySelector(`[js-cm-bar-ongoing]`).dataset.priceMessage) )
                return;
            }
            const widthPercent = Math.min((currentPrice / threshold) * 100, 100);
            checkedPurchaseType === 'purchaseTypeOneTime' ?
                ( bar.querySelector(`[js-progress-cm-width]`).style.width = `${widthPercent.toFixed(2)}%` ) :
                ( bar.hasAttribute(`js-with-drawer-shipping`) ? ( bar.querySelector(`[js-progress-cm-width]`).style.width = '100%' ) : ( bar.querySelector(`[js-progress-cm-width]`).style.width = `${widthPercent.toFixed(2)}%` ) );
            const remaining = Math.max(threshold - currentPrice, 0);
            checkedPurchaseType === 'purchaseTypeOneTime' ?
                (bar.hasAttribute(`js-with-drawer-shipping`) ? ( bar.querySelector(`[js-cm-bar-ongoing]`).classList.remove(`hidden`),bar.querySelector(`[js-cm-bar-success]`).classList.add(`hidden`),bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = `$${remaining.toFixed(2)} away from free shipping` ) : ( bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = `$${remaining.toFixed(2)} away from free gift` )) :
                (bar.hasAttribute(`js-with-drawer-shipping`) ? ( bar.querySelector(`[js-cm-bar-ongoing]`).classList.add(`hidden`),bar.querySelector(`[js-cm-bar-success]`).classList.remove(`hidden`) ) : ( bar.querySelector(`[js-cm-bar-ongoing]`).innerHTML = `$${remaining.toFixed(2)} away from free gift` ));
                bar.setAttribute('data-current-value',`$${remaining.toFixed(2)}`);
            if (widthPercent >= 100) {
                bar.querySelector(`[js-cm-bar-success]`)?.classList.remove('hidden');
                bar.querySelector(`[js-cm-bar-ongoing]`)?.classList.add('hidden');
            } else {
                checkedPurchaseType === 'purchaseTypeOneTime' ?
                ( bar.querySelector(`[js-cm-bar-success]`)?.classList.add('hidden'),bar.querySelector(`[js-cm-bar-ongoing]`)?.classList.remove('hidden') ) :
                ( bar.hasAttribute(`js-with-drawer-shipping`) ? (bar.querySelector(`[js-cm-bar-success]`)?.classList.remove('hidden'),bar.querySelector(`[js-cm-bar-ongoing]`)?.classList.add('hidden')) : (bar.querySelector(`[js-cm-bar-success]`)?.classList.add('hidden'),bar.querySelector(`[js-cm-bar-ongoing]`)?.classList.remove('hidden')) );
            }       
        }); 

        let thresholdShipping = parseFloat(document.querySelector(`[js-with-drawer-shipping]`).dataset.thresholdBar) || 0;
        let thresholdFreeGifts = parseFloat(document.querySelector(`[js-with-drawer-gifts]`).dataset.thresholdBar) || 0;
        if ( currentPriceOneTime >= thresholdShipping ) {
            document?.querySelectorAll(`.product_route__shipping_txt`)?.forEach((ships)=>{ ships.classList.add('hidden'); })
            document?.querySelectorAll(`[js-cm-shipping-eligible]`)?.forEach((ships)=>{ ships.classList.remove('hidden'); })
        }else{
            document?.querySelectorAll(`.product_route__shipping_txt`)?.forEach((ships)=>{ ships.classList.remove('hidden'); })
            document?.querySelectorAll(`[js-cm-shipping-eligible]`)?.forEach((ships)=>{ ships.classList.add('hidden'); })
        }                
        if ( currentPriceSubscribe >= thresholdFreeGifts ) {
            document?.querySelectorAll(`[js-cm-gifts-eligible]`)?.forEach((ships)=>{ ships.classList.remove('hidden'); })
        }else{
            document?.querySelectorAll(`[js-cm-gifts-eligible]`)?.forEach((ships)=>{ ships.classList.add('hidden'); })
        }                

        if( document.querySelector(`[js-drawer-communication-html]`).childElementCount > 2 ){
            if( (parseFloat(document?.querySelector(`[js-with-drawer-shipping]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100) && (checkedPurchaseType == 'purchaseTypeOneTime') ){
                let ShippingTextMsg = document?.querySelector(`.product__includes_bar.product__includes_bar__shipping`)?.querySelector(`.product__includes_bar__texts`)?.querySelector(`[js-cm-bar-ongoing]`)?.textContent;
                document?.querySelectorAll(`[js-mb-drawer-limit-items]`)?.forEach((el)=>{ el.classList.add('highlight'); el.textContent = `${ShippingTextMsg}` });
            }else if( parseFloat(document?.querySelector(`[js-with-drawer-gifts]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100 ){
                let GiftsTextMsg = document?.querySelector(`.product__includes_bar.product__includes_bar__gifts`)?.querySelector(`.product__includes_bar__texts`)?.querySelector(`[js-cm-bar-ongoing]`)?.textContent;
                document?.querySelectorAll(`[js-mb-drawer-limit-items]`)?.forEach((el)=>{ el.classList.add('highlight'); el.textContent = `${GiftsTextMsg}` });                          
            }else{
                document?.querySelectorAll(`[js-mb-drawer-limit-items]`)?.forEach((el)=>{ el.classList.add('highlight'); el.innerHTML = `<span class="product__includes_bar_msg_icon"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M1 7.1 5.78 12 14 3" stroke="#398200" stroke-width="1.25"></path></svg></span> <span class="product__includes_bar_msg_txt">Free gift</span>` });                    
            }
        }        
    }

    const updCmDrawerUpsellMessage = ()=>{
        const checkedPurchaseTypeEl = document.querySelector(`input[name="purchaseType"]:checked`)?.value;
        if( (checkedPurchaseTypeEl === 'purchaseTypeOneTime') && (parseFloat(document?.querySelector(`[js-with-drawer-shipping]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100) ){
            let currentValue = document?.querySelector(`[js-with-drawer-shipping]`).dataset.currentValue;
            document.querySelector(`[js-upsell-shipping-remaining-amt-outer]`).innerHTML = `Add ${currentValue} to get free shipping on your order.`;
        }else if( (checkedPurchaseTypeEl === 'purchaseTypeOneTime') && (parseFloat(document?.querySelector(`[js-with-drawer-gifts]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100) ){
            let currentValue = document?.querySelector(`[js-with-drawer-gifts]`).dataset.currentValue;
            document.querySelector(`[js-upsell-shipping-remaining-amt-outer]`).innerHTML = `Add ${currentValue} to get a free $24 gift on your order.`;
        }else if( (checkedPurchaseTypeEl === 'purchaseTypeSubscription') && (parseFloat(document?.querySelector(`[js-with-drawer-gifts]`)?.querySelector(`[js-progress-cm-width]`)?.style?.width) < 100) ){
            let currentValue = document?.querySelector(`[js-with-drawer-gifts]`).dataset.currentValue;
            document.querySelector(`[js-upsell-shipping-remaining-amt-outer]`).innerHTML = `Add ${currentValue} to get a free $24 gift on your order.`;
        }else{
            document.querySelector(`[js-upsell-shipping-remaining-amt-outer]`).innerHTML = `Round out your routine and save.`;
        }
        if( checkedPurchaseTypeEl === 'purchaseTypeOneTime' ){
            document?.querySelector(`[js-upsell-message-outer]`)?.classList.add(`hidden`);
        }else{
            document?.querySelector(`[js-upsell-message-outer]`)?.classList.remove(`hidden`);
        }
    }

    const SummaryDrawerMobileAnimation = (() => {
        let animationTimeout = null;
        return () => {
            const el = document.querySelector('[js-cm-drawer-mb-closed-bar-outer]');
            if (!el) return;
            if (animationTimeout) {
                clearTimeout(animationTimeout);
                animationTimeout = null;
            }
            el.classList.remove('bouncing');
            void el.offsetWidth;
            el.classList.add('bouncing');
            animationTimeout = setTimeout(() => {
                el.classList.remove('bouncing');
                animationTimeout = null;
            }, 1500);
        };
    })();

    const getGuid = ()=> {
        let d = new Date().getTime();
        let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
        }); 
    }

    const stickyNavBuildScroll = () => {
        var navLabels   = document.querySelectorAll('.twv__sticky__naviagtion_label');
        var sections    = document.querySelectorAll('[js-scroll-section]');
        var header      = document.querySelector('.section-header');
        var stk__nave   = document.querySelector('.this__sticky__nav__mn');
        var navScroller = document.querySelector('.twv__sticky__naviagtion_wp');
        var ticking     = false;
        var resizeTimer = null;
        if (!navLabels.length || !sections.length) return;
        function getOffsetTop(el) {
            var top = 0;
            while (el) {
                top += el.offsetTop;
                el   = el.offsetParent;
            }
            return top;
        }
        function clearAll() {
            for (var j = 0; j < navLabels.length; j++) {
                navLabels[j].classList.remove('active');
            }
        }
        function findNavMatch(targetVal) {
            if (!targetVal) return null;
            for (var k = 0; k < navLabels.length; k++) {
                var linkTarget = navLabels[k].getAttribute('href');
                linkTarget     = linkTarget ? linkTarget.replace('#', '') : '';
                if (linkTarget === targetVal) {
                    return navLabels[k];
                }
            }
            return null;
        }
        function scrollToActiveNav(activeLabel) {
            if (!navScroller || !activeLabel) return;
            var navScrollerRect = navScroller.getBoundingClientRect();
            var activeLabelRect = activeLabel.getBoundingClientRect();
            var labelCenter    = activeLabelRect.left + activeLabelRect.width / 2;
            var scrollerCenter = navScrollerRect.left + navScrollerRect.width / 2;
            var scrollOffset   = navScroller.scrollLeft + (labelCenter - scrollerCenter);
            try {
                navScroller.scrollTo({
                    left:     scrollOffset,
                    behavior: 'smooth'
                });
            } catch (e) {
                navScroller.scrollLeft = scrollOffset;
            }
        }
        function run() {
            var hHeight      = header    ? header.offsetHeight    : 0;
            var sNav         = stk__nave ? stk__nave.offsetHeight : 0;
            var headerHeight = parseInt(hHeight) + parseInt(sNav) + 32;
            var scrollTop    = window.scrollY || window.pageYOffset;
            var activeIndex  = -1;
            var firstSectionTop   = getOffsetTop(sections[0]) - headerHeight;
            var lastSection       = sections[sections.length - 1];
            var lastSectionBottom = getOffsetTop(lastSection) + lastSection.offsetHeight - headerHeight;
            if (scrollTop < firstSectionTop) {
                clearAll();
                ticking = false;
                return;
            }
            if (scrollTop >= lastSectionBottom) {
                clearAll();
                ticking = false;
                return;
            }
            for (var i = 0; i < sections.length; i++) {
                var sectionTop = getOffsetTop(sections[i]) - headerHeight;
                if (scrollTop >= sectionTop) {
                    activeIndex = i;
                }
            }
            clearAll();
            if (activeIndex !== -1) {
                var targetVal  = sections[activeIndex].dataset.targetEl || null;
                var matchedNav = findNavMatch(targetVal);
                if (matchedNav) {
                    matchedNav.classList.add('active');
                    scrollToActiveNav(matchedNav);
                }
            }
            ticking = false;
        }
        window.addEventListener('scroll', function () {
            if (!ticking) {
                requestAnimationFrame(run);
                ticking = true;
            }
        }, { passive: true });
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(run, 150);
        }, { passive: true });
        run();
    };
    stickyNavBuildScroll();

    const removeAlreadyAddInRecomm = () => {
        document.querySelectorAll('.product_route_recommendations_item').forEach((tg) => {
            tg.classList.remove('hidden');
        });
        document?.querySelectorAll(`[js-cm-drawer-outer]`)?.forEach((el) => {
            const cartHaveItem = el.dataset.mappedVariantId;
            if (cartHaveItem && cartHaveItem.trim() !== '') {
                document?.querySelectorAll(`.product_route_recommendations_item[data-product-variant-id="${cartHaveItem}"]`)
                    ?.forEach((tg) => { 
                        tg?.classList?.add('hidden'); 
                    });
            }
        });
    }

    document.body.addEventListener('click', function (event) {
        const addButton = event.target.closest('[js-button-confiq-add]');
        if (addButton) {
            event.preventDefault();
            const mainItemOuter = addButton.closest('[js-main-item-outer]');
            const configOuter = addButton.closest('[js-button-confiq-outer]');
            if (mainItemOuter && configOuter) {
                configOuter.classList.add('active');
                if (typeof updCommItemAdd === 'function') updCommItemAdd(mainItemOuter);
            }
            return;
        }

        const plusButton = event.target.closest('[js-button-confiq-plus]');
        if (plusButton) {
            event.preventDefault();
            const mainItemOuter = plusButton.closest('[js-main-item-outer]');
            const qtyContainer = plusButton.closest('[js-button-confiq-qty]');
            if (mainItemOuter && qtyContainer) {
                const inputElm = qtyContainer.querySelector('[js-button-confiq-input]');
                let currentQty = parseInt(inputElm.textContent || "1", 10);
                currentQty = currentQty + 1;
                inputElm.innerHTML = currentQty;
                if (currentQty > 1) {
                    qtyContainer.querySelector('[js-button-confiq-remove]')?.classList.add('hidden');
                    qtyContainer.querySelector('[js-button-confiq-minus]')?.classList.remove('hidden');
                }
                if (typeof updCommItemAdd === 'function') updCommItemAdd(mainItemOuter);
            }
            return;
        }

        const minusButton = event.target.closest('[js-button-confiq-minus]');
        if (minusButton) {
            event.preventDefault();
            const mainItemOuter = minusButton.closest('[js-main-item-outer]');
            const qtyContainer = minusButton.closest('[js-button-confiq-qty]');
            if (mainItemOuter && qtyContainer) {
                const inputElm = qtyContainer.querySelector('[js-button-confiq-input]');
                let currentQty = parseInt(inputElm.textContent || "1", 10);
                currentQty = currentQty - 1;
                inputElm.innerHTML = currentQty;
                if (currentQty === 1) {
                    qtyContainer.querySelector('[js-button-confiq-remove]')?.classList.remove('hidden');
                    qtyContainer.querySelector('[js-button-confiq-minus]')?.classList.add('hidden');
                }
                if (typeof updCommItemRemove === 'function') updCommItemRemove(mainItemOuter, false);
            }
            return;
        }
        const removeButton = event.target.closest('[js-button-confiq-remove]');
        if (removeButton) {
            event.preventDefault();
            const mainItemOuter = removeButton.closest('[js-main-item-outer]');
            const configOuter = removeButton.closest('[js-button-confiq-outer]');
            if (mainItemOuter && configOuter) {
                configOuter.classList.remove('active');
                if (typeof updCommItemRemove === 'function') updCommItemRemove(mainItemOuter, false);
            }
            return;
        }
    });

    document?.querySelector('[js-drawer-communication-html]')?.addEventListener('click', (target) => {
        const removeBtn = target.target.closest('[js-cm-drawer-remove]');
        if (removeBtn) {
            target.preventDefault();
            const drawerItemRow = removeBtn.closest('[js-cm-drawer-outer]');
            if (drawerItemRow) {
                updCommItemRemove(drawerItemRow, true);
            }
            return;
        }

        const minusBtn = target.target.closest('[js-cm-drawer-minus]');
        if (minusBtn) {
            target.preventDefault();
            const drawerItemRow = minusBtn.closest('[js-cm-drawer-outer]');
            if (drawerItemRow) {
                updCommItemRemove(drawerItemRow, true);
            }
            return;
        }

        const plusBtn = target.target.closest('[js-cm-drawer-plus]');
        if (plusBtn) {
            target.preventDefault();
            
            const drawerContainer = document.querySelector('[js-drawer-communication-html]');
            if (!drawerContainer) return;

            const drawerItemRow = plusBtn.closest('[js-cm-drawer-outer]');
            if (drawerItemRow) {
                const mappedTarget = drawerItemRow.dataset.mappedTarget;
                const targetVariantId = drawerItemRow.dataset.mappedVariantId;
                
                const newQty = (parseInt(drawerItemRow.dataset.mappedQuantity, 10) || 1) + 1;
                drawerItemRow.dataset.mappedQuantity = newQty;

                const qtyValueEl = drawerItemRow.querySelector('[js-cm-drawer-qty-value]');
                if (qtyValueEl) qtyValueEl.textContent = newQty;

                drawerItemRow.querySelector('[js-cm-drawer-remove]')?.classList.add('hidden');
                drawerItemRow.querySelector('[js-cm-drawer-minus]')?.classList.remove('hidden');

                let dashboardItem = document.querySelector(`[data-product-target="${mappedTarget}"]`);
                const singleDashboardItem = document.querySelector(`[data-product-variant-id="${targetVariantId}"]:not([data-product-target*="bundle"])`) || 
                                             document.querySelector(`[data-product-variant-id="${targetVariantId}"]`);

                if (dashboardItem) {
                    const isBundle = !!dashboardItem.querySelector(`[id="${mappedTarget}"]`);
                    const qtyInput = dashboardItem.querySelector('[js-button-confiq-input]');

                    if (isBundle) {
                        const remainingLines = drawerContainer.querySelectorAll(`[data-mapped-target="${mappedTarget}"]`);
                        let totalUnits = 0;
                        remainingLines.forEach(l => totalUnits += (parseInt(l.dataset.mappedQuantity, 10) || 0));
                        
                        let baseQtyPerGroupForThisVariant = 1;
                        let baseBundleUnitsCount = 1;
                        try {
                            const bundleItems = JSON.parse(dashboardItem.querySelector(`[id="${mappedTarget}"]`).textContent);
                            baseBundleUnitsCount = bundleItems.reduce((acc, item) => acc + (parseInt(item.quantity, 10) || 1), 0);
                            
                            const matchedItem = bundleItems.find(item => item.id == targetVariantId);
                            if (matchedItem) {
                                baseQtyPerGroupForThisVariant = parseInt(matchedItem.quantity, 10) || 1;
                            }
                        } catch(e){}
                        
                        const bundleCalculatedQty = Math.ceil(totalUnits / baseBundleUnitsCount);
                        if (qtyInput) qtyInput.innerHTML = bundleCalculatedQty;

                        if (bundleCalculatedQty > 1) {
                            dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.add('hidden');
                            dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.remove('hidden');
                        }
                        
                        if (singleDashboardItem && singleDashboardItem !== dashboardItem) {
                            const sQtyInput = singleDashboardItem.querySelector('[js-button-confiq-input]');
                            if (sQtyInput) {
                                const currentBundleCounter = parseInt(qtyInput.textContent, 10) || 1;
                                const bundleTotalPortion = currentBundleCounter * baseQtyPerGroupForThisVariant;
                                
                                let singleCalculatedQty = newQty - bundleTotalPortion;
                                if (singleCalculatedQty < 0) singleCalculatedQty = 0;

                                if (singleCalculatedQty === 0) {
                                    singleDashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.remove('active');
                                    sQtyInput.innerHTML = 1;
                                    singleDashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                                    singleDashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                                } else {
                                    singleDashboardItem.querySelector(`[js-button-confiq-outer]`)?.classList.add('active');
                                    sQtyInput.innerHTML = singleCalculatedQty;
                                    
                                    if (singleCalculatedQty === 1) {
                                        singleDashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.remove('hidden');
                                        singleDashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.add('hidden');
                                    } else {
                                        singleDashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.add('hidden');
                                        singleDashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.remove('hidden');
                                    }
                                }
                            }
                        }
                    } else {
                        if (qtyInput) qtyInput.innerHTML = newQty;
                        if (newQty > 1) {
                            dashboardItem.querySelector(`[js-button-confiq-remove]`)?.classList.add('hidden');
                            dashboardItem.querySelector(`[js-button-confiq-minus]`)?.classList.remove('hidden');
                        }
                    }
                }
                if (typeof updCommBuyButtonWMsg === 'function') updCommBuyButtonWMsg();
                if (typeof updCommPriceTotal === 'function') updCommPriceTotal();
            }
            return;
        }
    });
    
    document?.querySelectorAll(`input[name="purchaseType"]`).forEach((input)=>{
        input?.addEventListener('change', (tg)=>{
            updPriceAllOverPSelBased(tg.currentTarget.value);
            updCommProgressBar();
            updCmDrawerUpsellMessage();
        })
    });

    document?.querySelector(`[js-main-button]`)?.addEventListener('click',(tg)=>{
        tg.preventDefault();
        if( tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelectorAll(`.for__step__second`).length > 0 ){
            tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__second`).classList.add('active');
            tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__one`).classList.add('hidden');
            document?.querySelector(`.twv__split___renders__drawer`)?.classList?.add(`stepper__procced`);
            removeAlreadyAddInRecomm();
        }
    });

    document?.querySelector(`[js-cm-recommend-back-process]`)?.addEventListener('click',(tg)=>{
        tg.preventDefault();
        if( tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelectorAll(`.for__step__one`).length > 0 ){
            tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__second`).classList.remove('active');
            tg.currentTarget.closest(`[js-cm-main-outer-stepper]`).querySelector(`.for__step__one`).classList.remove('hidden');
            document?.querySelector(`.twv__split___renders__drawer`)?.classList?.remove(`stepper__procced`);
        }
    });
    
    document?.querySelectorAll(`[js-mobile-cm-drawer-open]`)?.forEach((dw)=>{
        dw?.addEventListener('click',(tg)=>{
            tg?.preventDefault();
            if( window.screen.width < 750 ){
                document.body.classList.toggle('mobile_drawerVisible');
                document.querySelector(`.page-blury-overlay`).classList.toggle(`is-visible`);
            }
        });
    });

    if( document.querySelectorAll('.play_paused___action .action--pause').length > 0 ){
        document.querySelectorAll('.play_paused___action .action--pause').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('[js-video-container]').querySelector('.action--play').classList.remove('hidden');
                target.target.closest('[js-video-container]').querySelector('video').pause();
            })
        });
        document.querySelectorAll('.play_paused___action .action--play').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('[js-video-container]').querySelector('.action--pause').classList.remove('hidden');
                target.target.closest('[js-video-container]').querySelector('video').play();
            })
        });  
    }  

    if (document.querySelectorAll(`[js-finally-takeover-submit]`).length > 0) {
        document.querySelectorAll(`[js-finally-takeover-submit]`).forEach((el) => {
            el.addEventListener('click', (tg) => {
                tg.preventDefault();
                const stepperContainer = tg.target.closest(`[js-cm-main-outer-stepper]`);
                const submitButton = tg.currentTarget;
                submitButton.classList.add('loading');
                submitButton.disabled = true;
                let cartElement = document.querySelector("cart-drawer");
                if (cartElement) cartElement.enableLoading();

                const mappedElements = stepperContainer
                    .querySelector(`.for__step__one`)
                    .querySelector(`[js-drawer-communication-html]`)
                    .querySelectorAll(`[data-mapped-variant-id]`);
                const purchaseTypeInput = stepperContainer.querySelector('[name="purchaseType"]:checked');
                const isSubscription = purchaseTypeInput && purchaseTypeInput.value === 'purchaseTypeSubscription';
                let uniqID = new Date().getTime().toString(),
                    bundleID = getGuid();

                const items = [];

                const idMap = {};
                let boxIndexCounter = 0;
                            
                mappedElements.forEach((item, index) => {
                    const variantId  = item.dataset.mappedVariantId;
                    const sellingId  = item.dataset.mappedSellingId;
                    const dynamicBoxID = item.dataset.mappedDynamicboxId;
                    const servingInCart = item.querySelector(`.dproute_serving_drawer`).textContent || '';
                    const lineQty = parseInt(item.dataset.mappedQuantity, 10) || 1;
                    const cartItem = {
                        id: variantId,
                        quantity: lineQty,
                    };

                    let dynamicBoxIndex = 0;
                    if (dynamicBoxID && dynamicBoxID.trim() !== '') {
                        if (idMap[dynamicBoxID] === undefined) {
                            idMap[dynamicBoxID] = boxIndexCounter;
                            boxIndexCounter++;
                        }
                        dynamicBoxIndex = idMap[dynamicBoxID];
                    }

                    if (isSubscription) {
                        if (sellingId && sellingId.trim() !== '') {
                            cartItem.selling_plan = sellingId;
                        }
                        if (dynamicBoxID && dynamicBoxID.trim() !== '') {
                            cartItem.properties = {
                                _dynamicBoxId: dynamicBoxID,
                                _dynamicBoxIndex: dynamicBoxIndex,
                                _original_qty: lineQty,
                                _bundle_id: bundleID,
                                _serving_txt:servingInCart,
                                _is_byob_child: "true",
                                _is_onetime:"false",
                                _uniq_id_lookup:uniqID
                            };
                        }
                    } else {
                        if (dynamicBoxID && dynamicBoxID.trim() !== '') {
                            cartItem.properties = {
                                _dynamicBoxId: dynamicBoxID,
                                _dynamicBoxIndex: dynamicBoxIndex,
                                _original_qty: lineQty,
                                _bundle_id: bundleID,
                                _serving_txt: servingInCart,
                                _is_byob_child: "true",
                                _is_onetime: "true",
                                _selling_plan_id: sellingId,
                                _uniq_id_lookup:uniqID
                            };
                        }
                    }
                    items.push(cartItem);
                });

                if (items.length === 0) {
                    if (cartElement) cartElement.disableLoading();
                    submitButton.classList.remove('loading');
                    submitButton.disabled = false;
                    return;
                }
                
                const productShouldBe = {
                    items: items,
                    sections: cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [],
                    sections_url: window.location.pathname
                };

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                .then((response) => response.json())
                .then((parsedState) => {
                    if (cartElement && parsedState.sections) {
                        cartElement.renderContent(parsedState.sections);
                    }
                })
                .catch((e) => console.error(e))
                .finally(() => {
                    if (cartElement) {
                        cartElement.disableLoading();
                        cartElement.open();
                    }
                    submitButton.classList.remove('loading');
                    submitButton.disabled = false;
                    clearAllCommHTMLAndResetDashboard();
                });
            });
        });
    } 

})